import { render, staticRenderFns } from "./QuotationStepAprroved.vue?vue&type=template&id=05d6e950&scoped=true"
import script from "./QuotationStepAprroved.vue?vue&type=script&lang=js"
export * from "./QuotationStepAprroved.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepAprroved.vue?vue&type=style&index=0&id=05d6e950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6e950",
  null
  
)

export default component.exports